const APP_NAME = 'COAL';
const DATA_API_KEY = '.data-api';

const html = document.documentElement;
const body = document.body;
let header = document.querySelector('.c-header');
let main = document.querySelector('main');
const scroll = document.querySelector('[data-module-scroll]');

export { APP_NAME, DATA_API_KEY, html, body, header, main, scroll };
